import { styled } from '@mui/material'
import { TextField } from '@collaborate-health/uikit'

export const SignatureInput = styled(TextField)({
  '&  input': {
    fontSize: '20px !important',
    fontFamily: 'Mr Dafoe',
    fontStyle: 'italic',
  },
})

